import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButtonModule } from '@angular/material/button';
import { LoaderButtonComponent } from '../loader-button/loader-button.component';
import { FileSelectorComponent } from '../file-selector/file-selector.component';
import { SUPPORTED_EXTENSIONS } from '@workspaces/utils/supported-extensions';
import { TemplateRequest } from '@workspaces/models/templates';
import { PersonaSelectorComponent } from '../persona-selector/persona-selector.component';

@Component({
  selector: 'app-template-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CdkTextareaAutosize,
    MatButtonModule,
    LoaderButtonComponent,
    FileSelectorComponent,
    PersonaSelectorComponent
  ],
  templateUrl: './template-form.component.html',
  styleUrls: ['./template-form.component.scss', '../../global-workspace-styles.scss']
})
export class TemplateFormComponent {
  @Input() loading = false;
  @Input() submitButtonText = 'Save';
  @Output() formSubmit = new EventEmitter<{ form: TemplateRequest; file: File | null }>();

  public readonly supportedFileExtensions = SUPPORTED_EXTENSIONS;
  public selectedFile: File | null = null;

  public readonly formControls = {
    name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    description: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    default_personas: new FormControl<string[]>([], { nonNullable: true })
  };

  public readonly form = new FormGroup(this.formControls);

  onFilesChanged(files: File[]): void {
    this.selectedFile = files.length > 0 ? files[0] : null;
  }

  onPersonasChanged(personaIds: string[]): void {
    this.form.patchValue({ default_personas: personaIds });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.formSubmit.emit({
      form: this.form.getRawValue(),
      file: this.selectedFile
    });
  }

  reset(): void {
    this.form.reset();
    this.selectedFile = null;
  }
}
